export default __webpack_public_path__ + "static/media/29-color.ebbbd92b.svg";